application.register("layout_reviews_aside", class extends Stimulus.Controller {
    close() {
        this.element.classList.add("is--closing");
    }
})
